
import { computed, defineComponent, reactive, ref, ComputedRef } from 'vue';
import Button from '@/components/ui-elements/form/Button.vue';
import Form from '@/components/ui-elements/form/Form';
import Input from '@/components/ui-elements/form/Input.vue';
import Select from '@/components/ui-elements/form/Select.vue';
import useTimestamp from '@/hooks/useTimestamp';
import useUtils from '@/hooks/useUtils';
import {
	useAggregationStore,
	useTypesStore,
	useUserStore,
	CommonExpenseTypeInterface,
} from '@/store';

export default defineComponent({
	components: {
		Button,
		Form,
		Input,
		Select,
	},
	setup(props, { emit }) {
		const { camelCase } = useUtils();
		const { getAllMonths } = useTimestamp();
		const aggregationStore = useAggregationStore();
		const userStore = useUserStore();
		const typesStore = useTypesStore();

		const form = reactive({
			bill_type: {
				rules: ['required'],
				value: '',
			},
			end_month: {
				rules: [],
				value: '12',
			},
			keywords: {
				rules: [],
				value: '',
			},
			start_month: {
				rules: {},
				value: '01',
			},
			type: {
				rules: [],
				value: '',
			},
			vehicle: {
				rules: [],
				value: '',
			},
			year: {
				rules: ['required'],
				value: '',
			},
		});
		const isFormValid = ref(false);
		const showNameInput = computed(
			() => !['vehicles'].includes(form.bill_type.value)
		);
		const showTypesSelect = computed(
			() => !['miscellaneous'].includes(form.bill_type.value)
		);
		const billTypes = computed(() => typesStore.bills);
		const vehicles = computed(() => userStore.vehicleList);
		const years = computed(() => aggregationStore.allYears);

		const billName = computed(() => {
			const type = billTypes.value.find(
				obj => obj.slug === form.bill_type.value
			);
			return type ? type.name : '';
		});

		const types: ComputedRef<CommonExpenseTypeInterface[]> = computed(
			() => (typesStore as any)[form.bill_type.value] ?? []
		);

		const resetForm = () => {
			form.bill_type.value = '';
			form.year.value = '';
		};

		const runSearch = () => {
			const formValues: Record<string, string> = {};

			for (const key of Object.keys(form)) {
				formValues[camelCase(key)] = (form as any)[key].value;
			}

			emit('run-search', formValues);
		};

		const updateExpenseType = (e: string) => {
			form.bill_type.value = e;
			form.type.value = '';
		};

		return {
			billTypes,
			form,
			billName,
			isFormValid,
			months: getAllMonths('abbr'),
			resetForm,
			runSearch,
			showNameInput,
			showTypesSelect,
			types,
			updateExpenseType,
			vehicles,
			years,
		};
	},
});
